import styled, { keyframes } from "styled-components";
import * as ANIMATION from "react-animations";
import { colors } from "~/assets/js/theme/constants";

const backdropIn = keyframes`${ANIMATION.fadeIn}`;
const backdropOut = keyframes`${ANIMATION.fadeOut}`;

const getPositionParams = (props) => {
    switch (props.position) {
        case "bottom":
            return `
            bottom: 20px;
            left: 0;
            right: 0;`;
        case "top":
            return `
            top: 20px;
            left: 0;
            right: 0;`;
        case "center":
            return `
            top: 50%;
            left: 50%;
            margin-top: -${Math.round(props.height / 2)}px;
            margin-left: -${Math.round(props.width / 2)}px;
        `;
    }
};

export const StyledPortal = styled.div`
    position: fixed;
    ${(props) => getPositionParams(props)}
    display: flex;
    flex-direction: row;
    justify-content: center;
    z-index: 21003;
    animation: 1000ms
        ${(props) => {
            switch (props.state) {
                case "in":
                    return keyframes`${ANIMATION[props.inAnimation]}`;
                case "out":
                    return keyframes`${ANIMATION[props.outAnimation]}`;
                default:
                    return "";
            }
        }};
    filter: drop-shadow(0px 0px 16px #00000070);
`;

export const Backdrop = styled.div`
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 21002;
    position: fixed;
    background-color: ${(props) =>
        !props.disabled ? `background-color: ${colors.WHITE}90;` : ""}
    backdrop-filter: blur(2px);
    animation: 1000ms
        ${(props) => (props.state === "in" ? backdropIn : backdropOut)};
`;
